import CompetitorIcon from 'presentation/components/competitor-icon/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';

const ParticipantItem = props => {
    const {
        participant,
        hasTeamLogo,
        src,
        mojitoTools: { config, style },
    } = props;

    const { name, shortName, startingPitcherName } = participant;
    const textStyle = startingPitcherName ? style.oneLineText : config.text;
    const participantName = config.showShortName && hasTeamLogo ? shortName : name;

    return (
        <FlexPane config={config.participantWrapper} class="ta-ParticipantItem">
            {config.showTeamLogo && hasTeamLogo && (
                <CompetitorIcon config={config.competitorIcon} title={name} src={src} />
            )}
            <FlexPane config={config.textWrapper}>
                <Text class="ta-participantName" config={textStyle}>
                    {participantName}
                </Text>
                {config.showStartingPitcher && startingPitcherName && (
                    <Text class="ta-startingPitcher" config={config.startingPitcherName}>
                        {startingPitcherName}
                    </Text>
                )}
            </FlexPane>
        </FlexPane>
    );
};

ParticipantItem.getStyle = (config, mode, merge) => {
    return {
        oneLineText: merge(config.text, { ellipsisOnLineNumber: 1 }),
    };
};

export default ParticipantItem;
